const FORM_DATEPICKER_FIELDS = [
  {
    label: "In-Production Date",
    key: "inProductionDate",
  },
  {
    label: "Requested Ship Date",
    key: "requestedShipDate",
  },
  {
    label: "Requested In-Hand Date",
    key: "requestedInHandDate",
  },
];

export default FORM_DATEPICKER_FIELDS;
